import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';
import { OrgChart } from 'd3-org-chart';
import styles from "../styles/CompanyTree.module.css";
import * as d3 from "d3"
import { MinusCircleOutlined, MinusCircleTwoTone, PlusCircleOutlined, PlusCircleTwoTone } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
const CompanyTreeOrganizationEdit = ({
  departmentList = [], lang = "",
  companyInformation = {},
  handleOpenCreateModal = () => { },
  handleOpenEditModal = () => { },
  onDeleteDepartment = () => { },
  handleCloseModal = () => { },
  organizationMaxLevel = 2
}) => {
  const chartRef = useRef(null);
  const [chart, setChart] = useState(null);
  // console.log("departmentList", transformData(departmentList));

  // Ensure that root data is structured properly
  // const rootData = [
  //   { id: 100, parentId: null, name: 'Steven King', position: 'Chief Operating Officer', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait12.png', email: 'SKING', phone_number: '515.123.4567', hire_date: '2003-07-16T19:00:00.000Z' },
  //   { id: 101, parentId: 100, name: 'Neena Kochhar', position: 'Administration Vice President', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait85.png', email: 'NKOCHHAR', phone_number: '515.123.4568', hire_date: '2005-10-20T20:00:00.000Z' },
  //   { id: 102, parentId: 100, name: 'Lex De Haan', position: 'Administration Vice President', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait16.png', email: 'LDEHAAN', phone_number: '515.123.4569', hire_date: '2001-02-12T20:00:00.000Z' },
  //   { id: 103, parentId: 100, name: 'Alexander Hunold', position: 'Programmer', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait17.png', email: 'AHUNOLD', phone_number: '590.423.4567', hire_date: '2006-02-02T20:00:00.000Z' },
  //   { id: 104, parentId: 103, name: 'Bruce Ernst', position: 'Programmer', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait18.png', email: 'BERNST', phone_number: '590.423.4568', hire_date: '2007-06-20T20:00:00.000Z' }
  // ];

  function transformData(data) {
    console.log("companyInformation", companyInformation);

    const result = [{ id: 'root', preventExpand: true, parentId: null, name: companyInformation.companyName, position: "", image: 'https://bumbeishvili.github.io/avatars/avatars/portrait12.png', email: 'SKING', phone_number: '515.123.4567', hire_date: '2003-07-16T19:00:00.000Z' }];

    function traverse(node, parentId = null) {
      const transformedNode = {
        ...node,
        id: node.organizationId || node.id,
        parentId: parentId || 'root',
        name: node.organizationName || node.name,
        position: node.organizationLevel?.name || 'Unknown Position',
        image: node.image || '',
        email: node.email || '',
        phone_number: node.phone_number || '',
        hire_date: node.hire_date || '',
        preventExpand: true,
      };

      result.push(transformedNode);

      if (node.children && node.children.length > 0) {
        node.children.forEach(child => traverse(child, transformedNode.id));
      }
    }
    data.map(o => traverse(o))
    return result;
  }

  useEffect(() => {
    // Log root data for debugging

    // Check if the root data is valid
    const chartContainer = chartRef.current;

    // Ensure chart container is available
    if (!chartContainer) {
      console.error("Chart container is not available.");
      return;
    }
    // Initialize OrgChart only after container is available
    const orgChart = new OrgChart()
      .nodeHeight((d) => 50 + 25)
      .nodeWidth((d) => 300 + 2)
      .childrenMargin((d) => 200)
      .compactMarginBetween((d) => 200)
      .compactMarginPair((d) => 200)
      .neighbourMargin((a, b) => 200)
      // .onNodeClick(d => { handleOpenEditModal(true, d.data) })

      .buttonContent(() => { })
      .nodeContent(function (d) {
        console.log("d", d.data?.level);

        const color = '#FFFFFF';
        const imageDiffVert = 25 + 2;
        const iconPlusHtml = ReactDOMServer.renderToString(
          <div
            id={`iconPlusHtml-${d.id}`}  // Unique id based on node data
            // onClick={() => {
            //   console.log("onClick");
            //   handleOpenCreateModal(true, d.data, true); // เปิด modal
            //   handleCloseModal();
            // }} 
            style={{ zIndex: 1000, position: "relative", top: "14px", right: "-145px", width: "30px" }}>
            {d.data?.level != organizationMaxLevel && <PlusCircleTwoTone
              twoToneColor={['#FFFFFF', 'green']}
              className={styles.miniplusBtn} style={{ color: '#3498db', fontSize: '30px' }} />
            }
          </div>); // Render React icon to HTML string
        const iconMinusHtml = ReactDOMServer.renderToString(<div id={`iconMinusHtml-${d.id}`}  // Unique id based on node data
          style={{ zIndex: 1000, position: "relative", bottom: "-1" * (45 + (d.data?.level != organizationMaxLevel ? 0 : -30)) + "px", right: "-85px", width: "30px" }}

        > {d.data?.id != 'root' && <MinusCircleTwoTone

          twoToneColor={['#FFFFFF', 'red']} className={styles.miniplusBtn} style={{ color: '#3498db', fontSize: '30px' }} />}

        </div>); // Render React icon to HTML string
        return `
          <div id='node-na' style="width:${d.width}px;height:${d.height}px;padding-left:1px;padding-right:1px;">
            <div style="font-family: 'Inter', sans-serif;background-color:${color};margin-left:-1px;width:${d.width - 2}px;border-radius:100px;border: 1px solid black ;padding-left :20px;padding-right :20px;">
              <div  id='nodeNa-${d.id}' style="margin-top:20px;min-height:${d.height + (d.data?.level != organizationMaxLevel ? 0 : 40)}px;align-content:center;font-size:1.3vw;color:#08011E;text-align:center ;white-space: normal; word-wrap: break-word; overflow: hidden; text-overflow: ellipsis;padding-left:10px;padding-right:10px;padding-top:20px;">${d.data?.name}
              </div>
                ${iconMinusHtml}
                ${iconPlusHtml}
            </div>
        </div>`;
      })
      .container(chartContainer)
      .data(transformData(departmentList))
      .render();

    // Set chart to state for future manipulation (optional)

    // After chart is rendered, attach event listeners using D3
    const svg = d3.select(chartContainer).select("svg");

    if (svg) {
      const defs = svg.append("defs");

      // Update connections with the arrowhead
      // .attr("marker-end", "url(#arrowhead)");
      svg.selectAll(".link")
        .style("stroke", "black"); // Example of dashed links (optional)
      svg.selectAll("foreignObject").remove()

      // console.log(" svg.select('iconPlusHtml')", svg.select('iconPlusHtml'));
      setTimeout(() => {
        // Attach event listener to iconPlusHtml
        d3.selectAll('[id^="iconPlusHtml-"]').on('click', function (event, d) {
          console.log("event.target.id", this.id);

          const nodeId = this.id.replace('iconPlusHtml-', ''); // Get the node ID
          console.log('Icon Plus Clicked on node:', nodeId);
          const nodeData = findNodeDataById(orgChart, nodeId);
          console.log('Node Data for Plus Icon Click:', nodeData?.under?.id);
          handleOpenCreateModal(true, nodeData, !nodeData?.under?.id); // Open create modal for the node
          handleCloseModal();
        });
        d3.selectAll('[id^="nodeNa-"]').on('click', function (event, d) {
          const nodeId = this.id.replace('nodeNa-', ''); // Get the node ID
          console.log('Icon Plus Clicked on node:', nodeId);
          const nodeData = findNodeDataById(orgChart, nodeId);
          console.log('Node Data for Plus Icon Click:', nodeData);
          handleOpenEditModal(true, nodeData)
        });

        // Attach event listener to iconMinusHtml
        d3.selectAll('[id^="iconMinusHtml-"]').on('click', function (event) {
          const nodeId = this.id.replace('iconMinusHtml-', ''); // Get the node ID
          const nodeData = findNodeDataById(orgChart, nodeId);
          console.log('Node Data for Plus Icon Click:', nodeData);
          onDeleteDepartment(nodeId); // Handle department deletion
          handleCloseModal();
        });
      }, 0);
    }

    // orgChart?.expandAll()
    // orgChart?.compact?.(false).render();
    // // Disable the expand/collapse button specifically
    // orgChart.nodeButtonWidth(() => 0).nodeButtonHeight(() => 0).render();
    orgChart.expandAll(false)
      .compact(false)
      .nodeButtonWidth(() => 0)
      .nodeButtonHeight(() => 0)
      .render();
    const rootNodeId = departmentList[0]?.id; // Assuming the first item is the root
    if (rootNodeId) {
      orgChart.setCentered(rootNodeId);
    }
    setChart(orgChart);
    // Cleanup on component unmount
    return () => {
      if (chart) {
        chart?.destroy?.();
      }
    };
  }, [departmentList, companyInformation]);


  // Function to find node data by nodeId
  function findNodeDataById(chart, nodeId) {
    let nodeData = null;
    console.log("chart", chart?.data().find(o => o.id == nodeId), nodeId);

    chart?.data()?.forEach((node) => {
      if (node.id === nodeId) {
        nodeData = node; // Return the node data
      }
    });

    return nodeData;
  }

  return (
    <div>
      <div className={styles.stylesNode}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
          {/* <Button onClick={() => chart.exportImg({ full: true })} style={{ marginRight: 10 }}>
            Download
          </Button>
          <Button onClick={() => {
            chart.nodeHeight(() => 125 + 25);
            chart.layout('left').render().fit()
          }}>
            left
          </Button>
          <Button onClick={() => {
            chart.nodeHeight(() => 50 + 25);
            chart.layout('top').render().fit()
          }}>
            top
          </Button> */}
        </div>
        <div style={{ width: "100%" }} ref={chartRef} className="chart-container"></div>
      </div>
    </div>
  );
};

export default CompanyTreeOrganizationEdit;
